"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M15.211 11.254l2.197-2.221a3.31 3.31 0 004.002-3.987L19.615 6.84l-1.937-.52-.52-1.935 1.794-1.796a3.306 3.306 0 00-3.985 4.003l-2.226 2.205 2.47 2.456zm1.115 2.016a1.36 1.36 0 00-1.784-.124L8.795 7.41l-.708-2.628a.6.6 0 00-.267-.331L4.765 2.834a.327.327 0 00-.364.056L2.893 4.399a.332.332 0 00-.056.367L4.453 7.82c.058.113.208.23.331.263l2.627.709 5.746 5.733a1.37 1.37 0 00.124 1.786l4.466 4.484a1.365 1.365 0 001.93 0l1.112-1.112a1.367 1.367 0 000-1.932l-4.463-4.481zm-9.734 1.697L8.73 12.74l2.373 2.481-2.074 2.185a3.306 3.306 0 01-3.985 4.004l1.795-1.796-.517-1.934-1.937-.52-1.795 1.794a3.31 3.31 0 014.002-3.987z" }), "Tools");
//# sourceMappingURL=Tools.js.map